import React, { useEffect, useState } from "react";
import "../../css/admin/adminDashboard.css";

const AdminDashboard = () => {
  return (
    <>
      <div className="dashboard-container">
        <div className="company-watermark">
          <div>{`Welcome to CA Studio!`}</div>
        </div>
        <div className="company-watermark-sub">
          <div>{"Manage Your Clients with Confidence."}</div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
